import React, { useState } from 'react';
import './ConsultantDetailsCard.css';
import { icons } from "../../icons";
import Exp from '../../Assets/Consultant/Exp';
import ConsultantConstant from './ConstultantConstant';
import SelectInput from "../../Global Functions/selectInput";
import { ToFirstCapital } from '../../Utils/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { acceptDeclineConsultant, blockUnblockConsultant } from '../../Redux/Actions/consultantAction';
import { Modal } from 'antd';

const ConsultantDetailsCard = ({ data, onViewDocumentClick, id }) => {
    const dispatch = useDispatch();

    const blockedData = useSelector((state) => state.consultantBlockUnblock);
    const statusdata = useSelector((state) => state.consultantAcceptDecline);
    const { enumsData } = useSelector((state) => state.enumsData || {});
    const accountStatusData = enumsData?.data?.AccountStatus || {};

    const [blockModalOpen, setBlockModalOpen] = useState(false);
    const [blockRemark, setBlockRemark] = useState("");
    const [isBlocking, setIsBlocking] = useState(false);

    const handleBlockButtonClick = () => {
        const isCurrentlyBlocked = blockedData?.data?.data?.account_status === "block";
        setIsBlocking(!isCurrentlyBlocked);
        setBlockModalOpen(true);
    };

    const handleConfirmBlock = () => {
        dispatch(blockUnblockConsultant({
            id: id,
            account_status: isBlocking ? "block" : "unblock",
            block_remarks: blockRemark || "No remarks"
        }));
        setBlockModalOpen(false);
        setBlockRemark("");
    };

    const handleStatusChange = (e) => {
        const selectedValue = e.target.value;
        dispatch(acceptDeclineConsultant({
            id: id,
            account_status: selectedValue
        }));
    };

    return (
        <div className="details_table_left">

            <div className="flex-container flex-justify-between gap-10 ">
                <div className="flex-container gap-10 align-center margin-h-10">
                    <img
                        style={{ borderRadius: "25px", width: "120px", height: "120px" }}
                        src={data?.profile_image || require("./../../Global Icons/AlternateImage.png")}
                        alt="Profile"
                    />
                    <div className='viewDoc-div'>
                        <button onClick={onViewDocumentClick} className="viewDoc-button">
                            {ConsultantConstant.VIEW_DOCUMENTS}
                        </button>
                        <button
                            onClick={handleBlockButtonClick}
                            className={`block-unblock ${blockedData?.data?.data?.account_status === "block" ? "btn-green" : "btn-red"
                                }`}
                        >
                            {blockedData?.data?.data?.account_status === "block" ? "Unblock" : "Block"}
                        </button>

                    </div>
                </div>
            </div>
   <span className="margin-0">{data?.first_name}{" "}{data?.last_name}</span>
            <div className="margin-h-10">
                <span className="span-builder">{ConsultantConstant.CONSULTANT_ID}</span>
                <h4 className="margin-0">{data?.consultant_id}</h4>
            </div>

            <div>
                <SelectInput
                    placeholder="Select an Option"
                    onChange={handleStatusChange}
                    value=""
                    label="Select Consultant Status"
                    name="builder_id"
                    options={Object.entries(accountStatusData).map(([_, value]) => ({
                        label: value.charAt(0).toUpperCase() + value.slice(1),
                        value: value,
                    }))}
                />
            </div>
            <div className="consultant_account_status">
                <img src={icons["Status"]} alt="" />
                <div>
                    <span className="span-consultant">Consultant Status</span>
                    <h4 className="margin-0">
                        {ToFirstCapital(statusdata?.data?.data?.account_status)}
                    </h4>
                </div>
            </div>

            <div className="line_container">
                <span>{ConsultantConstant.PRIMARY_CONTACT_DETAIL}</span>
                <hr />
            </div>

            <div className="flex-container gap-10 align-center margin-h-10">
                <img src={icons[ConsultantConstant.EMAIL]} alt="" />
                <div>
                    <span className="span-builder">{ConsultantConstant.EMAIL}</span>
                    <h4 className="margin-0">{data?.email}</h4>
                </div>
            </div>

            <div className="flex-container gap-10 align-center margin-h-10">
                <img src={icons["Phone Number"]} alt="" />
                <div>
                    <span className="span-builder">{ConsultantConstant.PHONE_NUMBER}</span>
                    <h4 className="margin-0">{data?.contact_number}</h4>
                </div>
            </div>

            <div className="flex-container gap-10 align-center margin-h-10">
                <img src={icons["ID"]} alt="" />
                <div>
                    <span className="span-builder">{ConsultantConstant.RERA_ID}</span>
                    <h4 className="margin-0">{data?.rera_id}</h4>
                </div>
            </div>
            <div className="flex-container gap-10 align-center margin-h-10">
                <img src={icons["Date"]} alt="" />
                <div>
                    <span className="span-builder">{ConsultantConstant.CREATED_AT}</span>
                    <h4 className="margin-0">{data?.created_at}</h4>
                </div>
            </div>
            <div className="flex-container gap-10 align-center margin-h-10">
                <Exp />
                <div>
                    <span className="span-builder">{ConsultantConstant.EXPERIENCE}</span>
                    <h4 className="margin-0">{data?.experience}</h4>
                </div>
            </div>
            <div>
                <span>{ConsultantConstant.BIO}</span>
                <div className='consultant-bio'>{data?.bio}</div>
            </div>
            <Modal
                open={blockModalOpen}
                onCancel={() => setBlockModalOpen(false)}
                onOk={handleConfirmBlock}
                okText="Confirm"
                cancelText="Cancel"
                centered
                title={isBlocking ? "Block Consultant" : "Unblock Consultant"}
            >
                <p>Please enter a remark for this action:</p>
                <textarea
                    value={blockRemark}
                    onChange={(e) => setBlockRemark(e.target.value)}
                    rows={4}
                    style={{ width: '100%' }}
                    placeholder="Enter remark here"
                />
            </Modal>

        </div>
    );
};

export default ConsultantDetailsCard;
